import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon lang-switcher__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#languages" })
], -1)
const _hoisted_2 = { class: "lang-switcher__label" }
const _hoisted_3 = {
  class: "lang-switcher__dropdown",
  ref: "innerSwitcher"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "lang-switcher__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header__lang lang-switcher", { 'is-active': this.model.active }]),
    style: { cursor: 'pointer' },
    ref: "switcher"
  }, [
    _createElementVNode("div", {
      class: "lang-switcher__item lang-switcher__item_empty",
      onClick: _cache[0] || (_cache[0] = () => _ctx.model.toggleSwitcher())
    }, [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_i18n_t, { keypath: "common.languages" })
      ])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AppLanguageCode, (lang) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["lang-switcher__item lang-switcher__item_nl", [`lang-switcher__item_${lang}`]]),
          key: lang
        }, [
          _createElementVNode("a", {
            onClick: _withModifiers(($event: any) => (_ctx.model.switchLang(lang)), ["stop","prevent"]),
            class: _normalizeClass({ 'is-active': lang === _ctx.model.lang })
          }, [
            _createElementVNode("img", {
              class: "lang-switcher__icon",
              src: `/img/languages/${lang}.svg`,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_i18n_t, {
                keypath: `lang.${lang}`
              }, null, 8, ["keypath"])
            ])
          ], 10, _hoisted_4)
        ], 2))
      }), 128))
    ], 512)
  ], 2)), [
    [_directive_click_outside, () => _ctx.model.toggleSwitcher(false)]
  ])
}